module.exports = fox._r("images/bg/bg_menu.png", __webpack_public_path__ + "images/bg/bg_menu.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/bg_menu.png
// module id = 1001
// module chunks = 4